import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1503Model } from './kymw1503.model';
import { RegistMarkService } from './api-services/regist-mark.service';
import { GetMarkGroupListService } from '../kymw1500/api-services/get-mark-group-list.service';
import { GetSupplyPromoteMarkDivListService } from '../kymw1500/api-services/get-supply-promote-mark-div-list.service';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { CheckboxLabelComponent } from 'src/app/commons/kymw02/checkbox-label/checkbox-label.component';

/**
 * マーク登録画面を管理するクラス
 *
 * @export KYMW1503Component
 * @class KYMW1503Component
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-kymw1503',
  templateUrl: 'kymw1503.component.html',
  styleUrls: ['kymw1503.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1503Component extends PlessViewHelperSub implements OnInit {

  @ViewChild('txt_StartOrderCode', { static: true }) txt_StartOrderCode: OrderCodeTextInputComponent;
  @ViewChild('txt_EndOrderCode', { static: true }) txt_EndOrderCode: OrderCodeTextInputComponent;
  @ViewChild('chk_DesignateCode', { static: true }) chk_DesignateCode: CheckboxLabelComponent;

  kymw1503Model: KYMW1503Model = new KYMW1503Model();

  // 親画面への連携用
  setKYMW1503Parameter: Function;

  /**
   *Creates an instance of KYMW1503Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW1503Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private registMarkService: RegistMarkService,
    private getMarkGroupListService: GetMarkGroupListService,
    private getSupplyPromoteMarkDivListService: GetSupplyPromoteMarkDivListService,
    private kymw00Model: KYMW00Model,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1503Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1503';

    // マークグループ一覧取得
    this.getMarkGroupListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmpty(data)) {
        this.kymw1503Model.markGroupList = [];
        // マークグループコードが取得できませんでした
        this.dialogService.openAlertGetMessage('E0127', [],
          (closeDetail) => {
            // はいボタン押下時
            if (closeDetail === PlessAlert.Yes_Error) {
              this.closeFunction();
            }
          }
        );
      }
      this.updateMarkGroupList(data);
    });

    // マーク区分一覧取得
    this.getSupplyPromoteMarkDivListService.execute((data: any) => {
      if (PlessViewUtilsSub.isEmpty(data)) {
        this.kymw1503Model.supplyPromoteMarkDivList = [];
        // マーク区分が取得できませんでした
        this.dialogService.openAlertGetMessage('E0128', [],
          (closeDetail) => {
            // はいボタン押下時
            if (closeDetail === PlessAlert.Yes_Error) {
              this.closeFunction();
            }
          }
        );
      }
      this.updateSupplyPromoteMarkDivList(data);
    });
    setTimeout(() => {
      this.chk_DesignateCode.checkbox.nativeElement.focus();
    })
  }

  /**
   * 「コード指定」チェックボックスクリックイベント処理
   *
   * @memberof KYMW1503Component
   */
  public eventDesignateCode_CLICKHandler(): void {
    if (this.kymw1503Model.designateCode) {
      this.kymw1503Model.markCodeEnabled = true;
    } else {
      this.kymw1503Model.markCodeEnabled = false;
      this.kymw1503Model.markCode = '';
    }
  }

  /**
   * チェックボックス「使用開始 指定無し」クリックイベント
   *
   * @memberof KYMW1503Component
   */
  public eventNotDesignateStart_CLICKHandler(): void {
    if (this.kymw1503Model.notDesignateStart) {
      this.kymw1503Model.startOrderCodeEnabled = false;
      this.kymw1503Model.startOrderCode = '';
    } else {
      this.kymw1503Model.startOrderCodeEnabled = true;
    }
  }

  /**
   * チェックボックス「使用終了 指定無し」クリックイベント
   *
   * @memberof KYMW1503Component
   */
  public eventNotDesignateEnd_CLICKHandler(): void {
    if (this.kymw1503Model.notDesignateEnd) {
      this.kymw1503Model.endOrderCodeEnabled = false;
      this.kymw1503Model.endOrderCode = '';
    } else {
      this.kymw1503Model.endOrderCodeEnabled = true;
    }
  }

  /**
   * 「追加」ボタン押下イベント処理
   *
   * @memberof KYMW1503Component
   */
  public eventAddMark_CLICKHandler(): void {
    if (!this.inputCheck()) {
      return;
    }

    // 入力した情報で%1を登録しますか？
    this.dialogService.openAlertGetMessage('Q0104', ['マーク情報'], (closeEvent: any) => {
      if (closeEvent === PlessAlert.Yes) {
        this.registMarkService.execute(this.kymw1503Model, () => {
          this.clearInput();
        })
      }
    });
  }

  /**
   * 入力チェック
   *
   * @return true:OK false:NG
   */
  private inputCheck(): boolean {
    // マーク名
    if (PlessViewUtilsSub.isEmpty(this.kymw1503Model.markName)) {
      this.dialogService.openAlertGetMessage('E0110', ['マーク名']);
      return false;
    }

    // グループコード
    if (PlessViewUtilsSub.isEmpty(this.kymw1503Model.selectedMarkGroup)) {
      this.dialogService.openAlertGetMessage('E0110', ['マークグループ']);
      return false;
    }

    // マーク区分
    if (PlessViewUtilsSub.isEmpty(this.kymw1503Model.selectedSupplyPromoteMarkDiv)) {
      this.dialogService.openAlertGetMessage('E0110', ['マーク区分']);
      return false;
    }

    // マークコード
    if (this.kymw1503Model.designateCode) {
      if (PlessViewUtilsSub.isEmpty(this.kymw1503Model.markCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['マークコード']);
        return false;
      }
    }

    // 使用開始 受注コード
    if (!this.kymw1503Model.notDesignateStart) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw1503Model.startOrderCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['使用開始受注コード']);
        return false;
      }

      // 存在チェック
      if (PlessViewUtilsSub.isEmpty(this.txt_StartOrderCode.selectedCatalogID)) {
        this.dialogService.openAlertGetMessage('E0122', ['使用開始受注コード']);
        return false;
      }
    }

    // 使用終了 受注コード
    if (!this.kymw1503Model.notDesignateEnd) {
      // 必須チェック
      if (PlessViewUtilsSub.isEmpty(this.kymw1503Model.endOrderCode)) {
        this.dialogService.openAlertGetMessage('E0110', ['使用終了受注コード']);
        return false;
      }
      // 存在チェック
      if (PlessViewUtilsSub.isEmpty(this.txt_EndOrderCode.selectedCatalogID)) {
        this.dialogService.openAlertGetMessage('E0122', ['使用終了 受注コード']);
        return false;
      }
    }

    // 「受注コード」チェック（使用開始／終了のチェックボックス「指定なし」が OFF の場合のみ）
    if ((!this.kymw1503Model.notDesignateStart) && (!this.kymw1503Model.notDesignateEnd)) {
      if (Number(this.kymw1503Model.startOrderCode) > Number(this.kymw1503Model.endOrderCode)) {
        this.dialogService.openAlertGetMessage('E0123', ['受注コード']);
        return false;
      }
    }

    return true;
  }

  /**
   * 入力を初期化
   */
  private clearInput(): void {
    // マークコード
    this.kymw1503Model.markCode = '';
    this.kymw1503Model.markCodeEnabled = false;
    // コード指定
    this.kymw1503Model.designateCode = false;
    // マーク名
    this.kymw1503Model.markName = '';
    // マークグループコード
    this.kymw1503Model.selectedMarkGroup = '';
    // マーク区分
    this.kymw1503Model.selectedSupplyPromoteMarkDiv = '';
    // 使用開始 指定無し
    this.kymw1503Model.notDesignateStart = true;
    // 使用開始 受注コード
    this.kymw1503Model.startOrderCode = '';
    this.kymw1503Model.startOrderCodeEnabled = false;
    // 使用終了 指定無し
    this.kymw1503Model.notDesignateEnd = true;
    // 使用終了 受注コード
    this.kymw1503Model.endOrderCode = '';
    this.kymw1503Model.endOrderCodeEnabled = false;
  }

  /**
   * マークグループリストを更新する
   *
   * @param serverData マークグループリストのサーバ取得データ
   * @memberof KYMW1503Component
   */
  public updateMarkGroupList(serverData: any) {
    this.kymw1503Model.markGroupList = this.createComboboxArray(serverData, { MarkGroupCode: '', Caption: '' });
  }

  /**
   * 販売促進マークリストを更新する
   *
   * @param serverData 販売促進マークリストのサーバ取得データ
   * @memberof KYMW1503Component
   */
  public updateSupplyPromoteMarkDivList(serverData: any): void {
    this.kymw1503Model.supplyPromoteMarkDivList = this.createComboboxArray(serverData, { CodeValue: '', CodeName: '' });
  }

  /**
   * コンボボックス用配列の作成
   *
   * @private
   * @param {*} comboboxDataArray サーバから取得されたコンボボックス用データ
   * @param {*} blankData 先頭の空白用データ
   * @returns {*}　コンボボックス用配列
   * @memberof KYMW1503Component
   */
  private createComboboxArray(comboboxDataArray: any, blankData: any): any {
    let tempList = [];
    tempList = comboboxDataArray;
    tempList.splice(0, 0, blankData);
    return tempList;
  }
}
